import { render } from "./NScanVulnerabilitiesTable.vue?vue&type=template&id=2fc47cf6&scoped=true"
import script from "./NScanVulnerabilitiesTable.vue?vue&type=script&lang=js"
export * from "./NScanVulnerabilitiesTable.vue?vue&type=script&lang=js"

import "./NScanVulnerabilitiesTable.vue?vue&type=style&index=0&id=2fc47cf6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc47cf6"]])

export default __exports__